<template>
    <b-modal ref="profile_modal"
             size="xl"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">{{__t('ADD_STOP')}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">

                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-content">

                        <div class="" v-if="restaurants.length > 0">
                            <label>
                                {{__t('FILTER_REST')}}
                            </label>

                            <v-select multiple
                                      :reduce="rest => rest.id"
                                      v-model="active_restaurants"
                                      class="imc_reasons"
                                      label="title"
                                      :filterable="true"
                                      :options=restaurants  >
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        <div>
                                            {{ option.title }}
                                        </div>
                                        <div>
                                            <small>
                                                {{option.uniq_id}} {{option.address}}
                                            </small>
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </div>

                        <div class="button_add mt-5 mb-4">
                            <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_prod()">
                                <span class="fal  fa-eject mr-1"></span>
                                {{__t('SELECT_PRODUCT')}}
                            </button>
                        </div>

                        <div class="prod_info" v-for="product in active_products">
                            <div class="user_profile bg-gradient-primary bd-callout bd-callout-info position-relative mt-2  px-2 p-1">
                                <div class="d-flex flex-row pt-2 pb-1">
                                <span class="status">
                                    <img class="profile-image rounded-circle d-inline-block" :src="get_prod_image(product)">
                                </span>

                                    <span class="position-absolute remove" v-on:click.stop.prevent="remove_item(product)" >
                                          <span  class="btn btn-danger btn-sm btn-icon waves-effect waves-themed">
                                              <i class="fal fa-times"></i>
                                          </span>
                                    </span>

                                    <div class="user_attrib ml-3">
                                        <div class="name d-block fw-700 text-dark">
                                            {{product.title}}
                                        </div>

                                        <div class="company small text-dark">
                                            {{product.price}}
                                        </div>
                                    </div>
                                </div>
                                <div class="clr"></div>
                            </div>
                        </div>

                    </div>
                </b-overlay>





            </div>

            <product_modal_list
                :selected_ids="active_products_ids"
                :is_multiple=true>
            </product_modal_list>

        </div>

        <template v-slot:modal-footer="{close}">

            <div class="add_list pt-2 pb-2">
                <button class="btn btn-md btn-block btn-outline-success waves-effect waves-themed"
                        :disabled=!can_work
                        :class="{'' : can_work}" v-on:click="add_stop">
                    <span class="fal   mr-1" :class="{'fa-check mr-1' : can_work, 'fa-eject' : !can_work}"></span>
                    {{ __t('PUSH_TO_STOP') }}
                </button>
            </div>

            <div class="add_list pt-2 pb-2">
                <button class="btn btn-md btn-block btn-outline-danger waves-effect waves-themed"
                        :disabled=!can_work
                        :class="{'' : can_work}" v-on:click="remove_stop">
                    <span class="fal   mr-1" :class="{'fa-check mr-1' : can_work, 'fa-eject' : !can_work}"></span>
                    {{ __t('CLEAR_FROM_STOP') }}
                </button>
            </div>

            <div class="modal-footer">
                <button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>
            </div>
        </template>

    </b-modal>
</template>

<script>
import product_modal_list from "../../../catalog/products/modal_list/product_modal_list";
import vSelect from 'vue-select'
export default {
    name: "add_stop",

    components : {
        product_modal_list,
        vSelect
    },
    props : {
        modal_position : {
            type : String,
            default : "right"
        },
    },
    created () {
        EventBus.$on("add_stop",res => this.work_click(res));
        EventBus.$on("close_stop",this.close);

        EventBus.$on('selected_prod', this.set_prod);
        EventBus.$on('select_product_list_modal', this.set_prods);


        this.load_restaurants();
    },

    beforeDestroy() {
        EventBus.$off('selected_prod',this.set_prod);
        EventBus.$off('select_product_list_modal', this.set_prods);

    },

    data() {

        return {
            is_load: false,
            is_show_modal: false,
            active_products : [],
            active_restaurants : [],
            active_locations : [],

            restaurants : [],
        }
    },
    methods : {
        async add_stop () {
            if(this.can_work) {
                this.is_load = true;
                await api.put('/internal/v1/catalog/stop_list/push',{
                    'product_ids' : this.active_products_ids,
                    'rest_ids' : this.active_rest_ids,
                })
                    .then(({data}) => {
                        this.is_load = false;
                        if (data.status === "operation_success") {
                            EventBus.$emit('show_toast', {err: this.__t('OPERATION_SET_WORK'), type: "success", title: this.__t('OPERATION_SET_WORK'),'position':'b-toaster-top-left'});
                            EventBus.$emit('reload_products')
                            this.close();
                        }
                    })
                    .catch(({response}) => {
                        this.is_load = false;
                        EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,'position':'b-toaster-top-left'})
                    });
            }
        },

        async remove_stop() {
            if(this.can_work) {
                this.is_load = true;
                await api.delete('/internal/v1/catalog/stop_list/remove',{
                    'product_ids' : this.active_products_ids,
                    'rest_ids' : this.active_rest_ids,
                })
                    .then(({data}) => {
                        this.is_load = false;
                        if (data.status === "operation_success") {
                            EventBus.$emit('show_toast', {err: this.__t('OPERATION_SET_WORK'), type: "success", title: this.__t('OPERATION_SET_WORK'),'position':'b-toaster-top-left'})
                            EventBus.$emit('reload_products')
                            this.close();
                        }


                    })
                    .catch(({response}) => {
                        this.is_load = false;
                        EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,'position':'b-toaster-top-left'})
                    });
            }
        },

        get_prod_image (attached_product) {
            return  '/product/' + attached_product.product_id +'/image/' + attached_product.client_id +'/100/100/' + attached_product.client_id  +'.webp'
        },

        add_prod() {
            EventBus.$emit('select_product_modal');
        },

        set_prod(prod) {

        },

        set_prods(prods) {
            console.log(prods);
            let current_active = JSON.parse(JSON.stringify(this.active_products));
            this.active_products = [];

            if(prods.length > 0) {
                prods.map(item => {
                    let to_push = {
                        'client_id' : item.client_id,
                        'product_code': item.product_code,
                        'product_id': item.id,
                        'price': item.price,
                        'title': item.title,
                    };
                    this.active_products.push(to_push);
                });
            }
        },

        async load_restaurants() {
            this.is_load = true;
            await api.post('/internal/v1/catalog/restaurants',{
                "list" : {
                    "limit" : 200,
                }
            })
                .then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.restaurants = data.data;
                    } else {
                        this.restaurants = [];
                    }
                })
                .catch(({response}) => {
                    this.is_load = false;
                    this.restaurants = [];
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });

        },


        remove_item(prod) {
            this.active_products = this.active_products.filter(item => {
                return parseInt(item.product_id) != parseInt(prod.product_id);
            })
        },

        work_click(rest_id) {
            this.is_show_modal = true;
        },


        close () {
            this.active_products = [];
            this.active_restaurants = [];
            this.active_locations = [];

            this.is_show_modal = false;
        },

    },



    computed : {

        can_work() {
            return this.active_products_ids.length > 0 && this.active_restaurants.length > 0;
        },

        active_products_ids() {
            if(this.active_products.length > 0) {
                return this.active_products.map(item => {
                    return item.product_id;
                });
            }

            return [];
        },

        active_rest_ids() {
            return this.active_restaurants;

            return [];
        },

        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        },
    }
}
</script>

<style scoped>

</style>
